import { useCallback } from 'react';
import { logContactToSession } from '../utils/sessionUtils';
import { logger } from '../utils/logger';
import type { ContactData } from './useContactExtraction';

export const useSessionLogging = () => {
  const logContactToSessionIfValid = useCallback((
    formType: string,
    contactData: ContactData,
    sourceData: { [key: string]: string }
  ) => {
    // Log contact information to session if we have phone or email
    if (contactData.Phone || contactData.Email) {
      const sessionFormType = formType?.toLowerCase() || 'chat';
      // Map form types to match the allowed types
      const mappedFormType = sessionFormType === 'finance' ? 'FinanceV1' : 
                           sessionFormType === 'contact' ? 'Contact' :
                           sessionFormType === 'offers' || sessionFormType === 'offer' ? 'Offers' :
                           sessionFormType === 'service' ? 'Service' :
                           sessionFormType === 'appointment' ? 'Appointment' : 'Chat';
      
      logContactToSession(mappedFormType as any, {
        name: contactData.Name,
        phone: contactData.Phone,
        email: contactData.Email,
        formData: sourceData
      });
    }
  }, []);

  return {
    logContactToSessionIfValid
  };
};